import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-account-statement',
  imports: [RouterOutlet],
  templateUrl: './account-statement.html',
  styleUrl: './account-statement.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountStatement {}
